import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=27819330&scoped=true"
import script from "./UploadModal.vue?vue&type=script&lang=ts"
export * from "./UploadModal.vue?vue&type=script&lang=ts"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=27819330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27819330",
  null
  
)

export default component.exports